






import { Component, Vue } from 'vue-property-decorator';
import 'animate.css';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/iconfont/iconfont.css';
import '@/assets/element-ui/dialog.css';
import '@/assets/element-ui/tabs.css';
import '@/assets/element-ui/checkbox.css';
import '@/assets/element-ui/message.css';
import User from "@/core/User";
// import $dataObj from '@/axios/cosUploadFile';

@Component
export default class App extends Vue {

  created(){
    let domain = window.location.host
    if( domain.indexOf('localhost')> -1){
      domain = 'iruptcy.com';
      // domain = 'bcpolz.com';
    }


    this.axios.post(this.$URL.PLATFORM, {domain: domain}).then((res: any) => {
      if (res.code == 1) {
        let data = res.data[0];
        console.log( domain  , res )
        // this.account.back_img = this.$dataObj.autograph.addAutograph(data.login_bg_img)
        if (res.data[0].name) {
          document.title = res.data[0].name
        }
        // let list = res.data[0];
        // this.system_info = list;
        // if( this.system_info.id === 74 ){
        //   this.system_info.name = this.system_info.name.split('若璞')[1];
        // }
        User.temporary('system_info').setBetch(data);
      }
    })
  }

  mounted(){

  }
}
